import React from "react";

import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import NotificationsIcon from "@mui/icons-material/Notifications";
import HelpIcon from "@mui/icons-material/Help";
import LanguageIcon from "@mui/icons-material/Language";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import logo from "../img/logoText.png";

export default function Navbar() {
  const openSidenavbar = () => {
    document.getElementById("mySidenav").style.width = "360px";
  };

  return (
    <nav className="bg-gray-500 px-24  flex justify-between">
      <div className="flex flex-row ">
        <IconButton onClick={openSidenavbar} disableRipple={true}>
          <MenuIcon
            className="menu-icon"
            sx={{ fontSize: 40, "&:hover": { color: "" } }}
          />
        </IconButton>
        <img src={logo} alt="logo" className=" h-16 mt-2 ml-4" />
      </div>

      <div className="flex flex-row gap-4">
        <IconButton disableRipple={true}>
          <NotificationsIcon />
        </IconButton>
        <IconButton disableRipple={true}>
          <HelpIcon />
        </IconButton>
        <hr />
        <IconButton>
          <LanguageIcon />
        </IconButton>
        <IconButton disableRipple={true} variant="outlined">
          <KeyboardArrowDownIcon />
        </IconButton>
        <hr />
        <IconButton>
          <AccountCircleIcon />
        </IconButton>
        <IconButton disableRipple={true}>
          <KeyboardArrowDownIcon />
        </IconButton>
      </div>
    </nav>
  );
}
